// noinspection JSJQueryEfficiency

require('../base');

$(function () {

    $('.help-button').on('click', function() {
        toggleSidepanel();
    });

    $('#config-sidebar-overlay').on('click', function() {
        toggleSidepanel();
    });

    $('.save-button').on('click', function() {
        let configSidebar = $('#config-sidebar');
        let configSidebarOverlay = $('#config-sidebar-overlay');
        configSidebar.find('.sidebar-content').hide();
        configSidebar.find('.sidebar-content > div').hide();
        let inquiryHash = $(this).data('inquiry-hash');
        let inquiryUniqid = $(this).data('inquiry-uniqid');

        $.ajax({
            method: 'GET',
            url: Routing.generate('config_save', {'hash': inquiryHash, 'uniqid': inquiryUniqid}),
            success: function (data) {
                if (data.status === 'success') {
                    if (data.html) {
                        configSidebar.find('.sidebar-save').html(data.html);
                        checkFormRequiredFields(configSidebar.find('form'));
                    }

                    configSidebar.find('.sidebar-save').show();
                    configSidebar.find('.sidebar-save > div').show();
                    configSidebar.addClass('transition').addClass('expanded');
                    configSidebarOverlay.addClass('visible');
                }
            },
            error: function() {
            },
            complete: function() {
            }
        });
    });

    $('.sidebar-save').on('click', '.cancel-button', function() {
        toggleSidepanel();
    });

    $('#inquiry-details-button').on('click', function() {
        $('#inquiry-details').toggleClass('expanded');
    });

    $('body.config').on('submit', 'form.inquiry-ajax-form', function () {
        let form = $(this);

        $.ajax({
            method: 'POST',
            url: form.attr('action'),
            data: form.serializeArray(),
            success: function(response) {
                if(response.status === 'success') {

                    if(typeof dataLayer !== 'undefined') {
                        // TODO: tracking
                    }

                    if (response.html && response.htmlBlockId) {
                        $('#' + response.htmlBlockId).html(response.html);
                        $('#' + response.htmlBlockId).find('select.select2').each(function() {
                            InitSelect2Field($(this));
                        });
                        $('#' + response.htmlBlockId).find('.select2entity[data-autostart="true"]').each(function() {
                            $(this).select2entity();
                            SetSelect2EntityPlaceholder($(this));
                        });
                    }

                    if (response.redirect) {
                        document.location = response.redirect;
                    }
                }
                if (response.status === 'error') {
                    // TODO: form errors
                }
            },
            error: function() {
                // TODO
            },
            complete: function() {
                $('.search-city-autocomplete').each(function() {
                    InitCityAutocomplete($(this));
                });
                $('select.nice-select').each(function() {
                    InitNiceSelectField($(this));
                });
                // if (formId === 'inquiry-place-form') {
                //     form.find('button[type="button"].button-next').attr('disabled', 'disabled').addClass('disabled');
                //     if ($('#inquiry_place_city').val()) {
                //         if ($('#inquiry_place_establishment').val()) {
                //             $('#' + formId).find('button[type="button"].button-next').removeAttr('disabled').removeClass('disabled');
                //         }
                //         else if ($('#inquiry_place_custom').val() && $('#inquiry_place_name').val() && $('#inquiry_place_address1').val()) {
                //             $('#' + formId).find('button[type="button"].button-next').removeAttr('disabled').removeClass('disabled');
                //         }
                //     }
                // }
            }
        });

        return false;
    });

    $('body.config').on('autocompleteselect', 'input#inquiry_place_citySearch', function (event, ui) {
        $(this).val(ui.item.value);
        $('#inquiry_place_city').val(ui.item.id).trigger('change');
    });

    $('body.config').on('change', 'input#inquiry_place_city[data-change="load-establishments"]', function () {
        let form = $(this).closest('form');
        $('#inquiry_place_establishment').val('');
        $('#inquiry_place_establishment').select2().trigger('change');
        form.submit();
    });

    $('body.config').on('change', 'select#inquiry_place_establishment', function () {
        let form = $(this).closest('form');
        $('#inquiry_place__submitAndNext').val(0);
        $('#inquiry_place_custom').val(0);
        form.submit();
    });

    $('body.config').on('click', 'button[type="button"].button-next', function () {
        let buttonId = $(this).attr('id');
        let hiddenFieldId = buttonId.replace('_submitAndNext', '__submitAndNext');
        $('#'+hiddenFieldId).val(1);
        let form = $(this).closest('form');
        form.submit();
    });

    $('body.config').on('click', 'button[type="button"].button-skip', function () {
        let form = $(this).closest('form');
        form.submit();
    });

    $('body.config').on('click', 'button[type="button"].button-add', function () {
        let buttonId = $(this).attr('id');
        let hiddenFieldId = buttonId.replace('_submitAndAdd', '__submitAndAdd');
        $('#'+hiddenFieldId).val(1);
        let form = $(this).closest('form');
        form.submit();
    });

    $('body.config').on('click', 'button[type="button"].button-not-found', function () {
        let buttonId = $(this).attr('id');
        $('#inquiry_place_establishment').val('');
        let hiddenFieldId = buttonId.replace('_notFound', '_custom');
        $('#'+hiddenFieldId).val(1);
        let form = $(this).closest('form');
        form.submit();
    });

    $('body.config').on('keyup change', 'input#inquiry_place_city, input#inquiry_place_citySearch, input#inquiry_place_name, input#inquiry_place_address1', function () {
        let form = $(this).closest('form');
        let buttonNext = form.find('button[type="button"].button-next');
        buttonNext.attr('disabled', 'disabled').addClass('disabled');
        if ($('#inquiry_place_custom').length && $('#inquiry_place_name').val() && $('#inquiry_place_address1').val()) {
            // Etablissement perso
            buttonNext.removeAttr('disabled').removeClass('disabled');
        }
        else if (!$('#inquiry_place_custom').length && $('#inquiry_place_city').val() && ($('#inquiry_place_address1').val() || !$('#inquiry_place_address1').length)) {
            // Adresse perso OU choix ville cimetière (pas d'adress)
            buttonNext.removeAttr('disabled').removeClass('disabled');
        }
    });

    $('body.config').on('change', 'form#inquiry-date-slots-form input[type="checkbox"]', function () {
        let checkboxName = $(this).attr('name');
        let nbChecked = $('.inquiry-date-slots-form input[name="' + checkboxName + '"]:checked').length;
        if (nbChecked === 0) {
            $('#inquiry_dates_submitAndNext').attr('disabled', true).addClass('disabled');
        }
        else {
            $('#inquiry_dates_submitAndNext').removeAttr('disabled').removeClass('disabled');

            if (nbChecked >= 3) {
                $('.inquiry-date-slots-form input[name="' + checkboxName + '"]:not(:checked)').each(function() {
                    $(this).attr('disabled', true);
                    $(this).closest('.form-group').addClass('disabled');
                });
            }
            else {
                $('.inquiry-date-slots-form input[name="' + checkboxName + '"]').each(function() {
                    $(this).removeAttr('disabled');
                    $(this).closest('.form-group').removeClass('disabled');
                });
            }
        }
    });
    $('form#inquiry-date-slots-form input[type="checkbox"]').trigger('change');

    $('body.config').on('change', 'select#inquiry_religion_religion', function () {
        if ($(this).val()) {
            $('button#inquiry_religion_submitAndNext').removeAttr('disabled').removeClass('disabled');
        }
        else {
            $('button#inquiry_religion_submitAndNext').attr('disabled', true).addClass('disabled');
        }
    });

    $('body.config').on('keyup change', 'form.inquiry-check-required-form *[required="required"]', function () {
        let form = $(this).closest('form');
        checkFormRequiredFields(form);
    });
    $('body.config form.inquiry-check-required-form').each(function () {
        checkFormRequiredFields($(this));
    });

    $('body.config').on('click', 'form#inquiry-death-notice-form .button-catchphrases', function () {
        let categoryCode = $(this).data('category-code');
        toggleSidepanel(categoryCode);
    });

    $('#config-sidebar').on('click', '.catchphrases-list button', function () {
        let list = $(this).closest('.catchphrases-list');
        let textToAppend = $(this).html().trim();
        let textareaTarget = $('body.config .catchphrase-field.' + list.data('category-code') + ' > textarea');
        let textareaVal = textareaTarget.val();
        if (textareaVal.trim()) {
            textToAppend = "\n" + textToAppend;
        }
        textareaTarget.val(textareaVal + textToAppend).trigger('change');
        toggleSidepanel();
    });

    $('body.config').on('change', 'select#inquiry_newspaper_deathNoticeNewspaperDepartment', function () {
        let form = $(this).closest('form');
        $('#inquiry_newspaper_deathNoticeNewspaper1').val('');
        $('#inquiry_newspaper_deathNoticeNewspaper1').select2().trigger('change');
        $('#inquiry_newspaper_deathNoticeNewspaper2').val('');
        $('#inquiry_newspaper_deathNoticeNewspaper2').select2().trigger('change');
        form.submit();
    });

    $('body.config').on('change', 'select.inquiry-newspaper-select', function () {
        let form = $(this).closest('form');
        form.submit();
    });

    $('body.config.summary').on('keyup change', 'form#inquiry-contact-form *[required="required"]', function () {
        let form = $(this).closest('form');
        checkFormRequiredFields(form);
    });

    $('#inquiry-contact-form').on('submit', function() {
        let form = $(this);

        let loadingPopin = $('#inquiry-send-loading');
        let loadingBar = $('#inquiry-send-loading-bar');

        loadingPopin.removeClass('hidden');

        clearAjaxFormError(form);

        form.find('button').attr('disabled', true);

        $.ajax({
            method: 'POST',
            url: form.attr('action'),
            data: form.serializeArray(),
            success: function(response) {

                loadingBar.animate({
                    width: '100%',
                }, response.status === 'success' ? 5000 : 500, function() {
                    handleAjaxFormResponse(form, response);
                    if (response.status === 'success' && response.redirect) {
                        document.location = response.redirect;
                    }
                    else {
                        loadingPopin.addClass('hidden');
                        loadingBar.width(0);
                    }
                });
            },
            error: function() {
                handleAjaxFormErrors(form, []);

                loadingBar.animate({
                    width: '100%',
                }, 1000, function() {
                    loadingPopin.addClass('hidden');
                        loadingBar.width(0);
                });
            },
            complete: function() {
                form.find('button').removeAttr('disabled');
            }
        });

        return false;
    });

    $('#review-rating-stars').on('click', '.rating-star', function() {
        let rating = $(this).data('star-num');
        $('#review_rating').val(rating);
        $('.rating-star').each(function() {
            if ($(this).data('star-num') <= rating) {
                $(this).find('.icon-star-full').removeClass('off').addClass('on');
            }
            else {
                $(this).find('.icon-star-full').addClass('off').removeClass('on');
            }
        })
    })

    const $helpSidebarOverlay = $('#help-sidebar-overlay');
    $('button#help-toggle').on('click', function() {
        const $helpSidebar = $(this).closest('#help-sidebar');
        const helpSidebarIsClosed = $helpSidebar.hasClass('closed');
        $helpSidebar.toggleClass('closed');
        $helpSidebarOverlay.toggleClass('visible', helpSidebarIsClosed)

    });
});

function toggleSidepanel(catchphraseCategoryCode = null) {
    let configSidebar = $('#config-sidebar');
    let configSidebarOverlay = $('#config-sidebar-overlay');
    if (!configSidebar.hasClass('expanded')) {
        configSidebar.find('.sidebar-content').hide();
        configSidebar.find('.sidebar-content > div').hide();
        if (catchphraseCategoryCode) {
            configSidebar.find('.sidebar-catchphrases > div.catchphrases-' + catchphraseCategoryCode).show();
            configSidebar.find('.sidebar-catchphrases').show();
        }
        else {
            configSidebar.find('.sidebar-content-blocks').show();
            configSidebar.find('.sidebar-content-blocks > div').show();
        }
    }
    configSidebar.addClass('transition').toggleClass('expanded');
    configSidebarOverlay.toggleClass('visible');
    if (!configSidebar.hasClass('expanded')) {
        window.setTimeout(function() {
            configSidebar.find('.sidebar-content').hide();
            configSidebar.find('.sidebar-content > div').hide();
        }, 1000);
    }
}

function checkFormRequiredFields(form) {
    let hasEmptyField = false;
    form.find('*[required="required"]').each(function() {
        if ($(this).attr('type') === 'checkbox') {
            if (!$(this).is(':checked')) {
                hasEmptyField = true;
            }
        }
        else if (!$(this).val()) {
            hasEmptyField = true;
        }
    });
    if (!hasEmptyField) {
        form.find('button.button-next').removeAttr('disabled').removeClass('disabled');
        form.find('button[type="submit"]').removeAttr('disabled').removeClass('disabled');
    }
    else {
        form.find('button.button-next').attr('disabled', true).addClass('disabled');
        form.find('button[type="submit"]').attr('disabled', true).addClass('disabled');
    }
}